import type { ScriptV4 } from "./types.js";

export function blankScriptV4(title = ""): ScriptV4 {
  return {
    version: 4,
    title,
    worldview: "",
    style: "",
    actors: [],
    locations: [],
    props: [],
    episodes: [],
  };
}
